import {ListItemText} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import React, {useState} from "react";
import {renameMachine} from "../../../../api/machine-functions";
import {useApiNotification} from "../../../ui/ApiNotificationProvider";
import ListItem from "@material-ui/core/ListItem";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {useTheme} from "@material-ui/core/styles";
import {Machine} from "../../../../models/machine.models";

interface MachineRenameActionProps extends Machine {
    onRenamed: (newName: string) => void;
    onCancel: () => void;
}

export const MachineRenameAction = (props: MachineRenameActionProps) => {
    const {t} = useTranslation();
    const {id, name, onCancel, onRenamed} = props;
    const [friendlyName, setFriendlyName] = useState(props.friendlyName);
    const [disableBtns, setDisableBtns] = useState(false);
    const [showRenameDialog, setShowRenameDialog] = useState(false);
    const {showSuccess, handleError} = useApiNotification();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const renameHandler = () => {
        if (!friendlyName)
            return;

        setDisableBtns(true);

        renameMachine({userId: id, friendlyName})
            .then(() => {
                showSuccess();
                onRenamed(friendlyName);
                setShowRenameDialog(false);
            })
            .catch(handleError)
            .finally(() => {
                setDisableBtns(false);
            });
    }

    const cancelHandler = () => {
        onCancel();
        setShowRenameDialog(false);
    }

    return <>
        <ListItem onClick={() => setShowRenameDialog(true)}>
            <ListItemText style={{cursor: 'pointer'}}>
                {t('Machine.Actions.RenameMachine.Title')}
            </ListItemText>
        </ListItem>
        <Dialog aria-labelledby="customized-dialog-title" open={showRenameDialog} fullScreen={fullScreen}>
            <DialogTitle id="customized-dialog-title">
                {t('Machine.Actions.RenameMachine.DialogTitle')} - {name}
            </DialogTitle>
            <DialogContent dividers style={{minWidth: '300px'}}>
                <Grid>
                    <TextField
                        name='friendlyName'
                        error={!friendlyName}
                        value={friendlyName}
                        onChange={e => setFriendlyName(e.target.value)}
                        label={t('Machine.MachineName')}
                        helperText={!friendlyName ? t(`_Common.Messages.FieldIsRequired`) : null}
                    />
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" color="primary" onClick={cancelHandler} disabled={disableBtns}>
                    {t('_Common.Labels.Cancel')}
                </Button>
                <Button variant="contained" color="primary" onClick={renameHandler} disabled={disableBtns}>
                    {t('_Common.Labels.Save')}
                </Button>
            </DialogActions>
        </Dialog>
    </>
}
